import React, {useEffect, useState} from 'react';
import {NavLink, useParams} from "react-router-dom";
import Pagination from "@mui/material/Pagination";

interface QuestionHelpListProps {
    worrySearch: string;
    setWorrySearch: (newWorrySearch: string) => void;
    selectedProblem: string;
    questionsData: any[];
}

const QuestionHelpList = (props: QuestionHelpListProps) => {
    const {category, faq} = useParams();

    const [currentPage, setCurrentPage] = useState(1);
    const ITEMS_PER_PAGE = 3;
    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    const endIndex = startIndex + ITEMS_PER_PAGE;

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    }

    useEffect(() => {
        handlePageChange(1);
        console.log("QuestionHelpList category: ", category);
        console.log("QuestionHelpList faq: ", faq);
        console.log("QuestionHelpList props: ", props.questionsData);
    }, [props.questionsData, faq, category]);


    const scrollToTop = () => {
        window.scrollTo({ top: 187, behavior: 'smooth' });
    };

    const renderQuestionsByTopic = () => {
        console.log("QuestionHelpList props: ", props.questionsData);
        const filteredQuestions =
            props.worrySearch !== ""
                ? props.questionsData.map((item: any) => ({
                        ...item,
                        data: item.data.filter(
                            (it: any) =>
                                it.title.toLowerCase().includes(props.worrySearch.toLowerCase()) ||
                                it.question.toLowerCase().includes(props.worrySearch.toLowerCase()) ||
                                it.answer.toLowerCase().includes(props.worrySearch.toLowerCase())
                        ),
                    })).filter((item: any) => item.data.length > 0).flatMap((item: any) => item.data)
                : props.selectedProblem !== ""
                    ? props.questionsData.filter(
                            (item: any) =>
                                item.topic.toLowerCase() === props.selectedProblem.toLowerCase()
                            ).flatMap((item: any) => item.data)
                    : props.questionsData.flatMap((item: any) => item.data);

        const mergedData: any[] = filteredQuestions;

        console.log("QuestionHelpList mergedData: ", mergedData);

        const paginatedData = mergedData.slice(startIndex, endIndex);

        console.log("QuestionHelpList paginatedData: ", paginatedData);

        const totalPages = Math.ceil(mergedData.length / ITEMS_PER_PAGE);

        return(
            <div className="questionHelpList__container_content_list_wrap">
                <div className="questionHelpList__container_content_list">
                    {
                        mergedData.length > 0 ? (
                            <>
                                {
                                    mergedData.map((item, index) => (
                                        <div className="questionHelpList__container_content_list_item" key={index}>
                                            <div className="questionHelpList__container_content_list_item_question">
                                                <span>{item.question}</span>
                                            </div>
                                            <div className="questionHelpList__container_content_list_item_topic">
                                                <div className="questionHelpList__container_content_list_item_topic_title">
                                                    <span>Topic:</span>
                                                </div>
                                                <div className="questionHelpList__container_content_list_item_topic_content">
                                                    <span>{item.title}</span>
                                                </div>
                                            </div>
                                            <div className="questionHelpList__container_content_list_item_answer">
                                                <span>{item.answer}</span>
                                            </div>
                                        </div>
                                    ))
                                }
                            </>
                        ) : (
                            <>
                                <div className="questionHelpList__container_content_list_wrap_no_questions">
                                    <span>There are no questions/answers on this topic yet, you can ask us your question</span>
                                    <div className="questionHelpList__container_content_list_wrap_no_questions_redirect">
                                        <NavLink to="/contact-us">Ask a Question</NavLink>
                                    </div>
                                </div>
                            </>
                        )
                    }
                </div>
                <div className="questionHelpList__container_content_list_pagination">
                    {
                        totalPages > 1 && (
                            <div className="orderMainFoodProductList__container-items-pagination">
                                <div className="orderMainFoodProductList__container-items-pagination-wrap">
                                    <Pagination
                                        count={totalPages}
                                        page={currentPage}
                                        onChange={(e, page) => {
                                            handlePageChange(page)
                                            scrollToTop();
                                        }}
                                        shape="rounded"
                                        style={{
                                            color: "#3A3A3A",
                                            backgroundColor: "#fff",
                                            borderRadius: "5px",
                                            padding: "5px",
                                            border: "none",
                                            paddingLeft: currentPage === 1 ? "38px" : "0",
                                            paddingRight: currentPage === totalPages ? "38px" : "0",
                                        }}
                                        hidePrevButton={currentPage === 1}
                                        hideNextButton={currentPage === totalPages}
                                    />
                                </div>
                            </div>
                        )
                    }
                </div>
            </div>
        )
    }

    return (
        <div className="questionHelpList__container">
            <div className="questionHelpList__container_content">
                {
                    renderQuestionsByTopic()
                }
            </div>

        </div>
    );
};

export default QuestionHelpList;